import Model, { attr } from '@ember-data/model';

export default class HomeawayConnectionModel extends Model {
  @attr('string') accountName!: string;
  @attr('boolean') autoNewListingPromotion!: boolean;
  @attr('number') newListingPromotionPercentage!: number;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'homeaway-connection': HomeawayConnectionModel;
  }
}
